import { push } from "react-router-redux";
import type { Dispatch } from "react-redux";
import { INSIGHTS } from "constants/action-types";
import type { IStore } from "reducers";

export const toggleCartInsightsSidePanel = () => ({
    type: INSIGHTS.CART_SIDE_PANEL_TOGGLE,
});

export const toggleCartInsightsSidePanelOpen = () => ({
    type: INSIGHTS.CART_SIDE_PANEL_TOGGLE_OPEN,
});

export const toggleGalleryInsightsSidePanel = () => ({
    type: INSIGHTS.GALLERY_SIDE_PANEL_TOGGLE,
});

export const closeGalleryInsightsSidePanel = () => ({
    type: INSIGHTS.GALLERY_SIDE_PANEL_CLOSE,
});

export const fetchBadges = () => ({
    type: INSIGHTS.FETCH_BADGES.START,
});

export const redirectToProductPage = (productId: string, queryParam: { orderType: string } | null = null) => {
    return (dispatch: Dispatch<{}>, getState: () => IStore) => {
        const brandId = getState().scope?.brand?._id;

        dispatch(push({ pathname: `/brand/${brandId}/item/${productId}`, query: queryParam }));
    };
};

export const clearInsightsData = () => ({
    type: INSIGHTS.CLEAR,
});
